import Grid from '@mui/material/Grid';
import { CajasProvider } from "src/context/CajasContext/CajasContext";
import { AdministracionContenidosList } from "../components/AdministracionContenidosList";
import { PageHeaderCard } from 'src/general_components/PageHeaderCard';
import FolderOpenIcon from "@mui/icons-material/FolderOpen";

export function AdministracionContenidos() {

  let url = window.location.href;
  const arrUrl = url.split('/');
  const proceso = arrUrl[arrUrl.length - 1];
  var titulo = "";
  if (proceso === "impresion") {
    titulo = "Impresión de etiquetas";
  } else if (proceso === "edit") {
    titulo = "Edición de Contenidos";
  } else if (proceso === "list") {
    titulo = "Consulta de Contenidos";
  }

  return (
    <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
      <PageHeaderCard title={titulo} icon={<FolderOpenIcon />} />
      <CajasProvider>
        <Grid>
          <AdministracionContenidosList />
        </Grid>
      </CajasProvider>
    </Grid>
  );
}
